import { useState } from "react";
import clsx from "clsx";
import { useTranslation } from "react-i18next";
import { HiOutlineDocumentText, HiOutlineXCircle } from "react-icons/hi2";

import { useToast } from "@/hooks/useToast";
import FeaturedText from "@/components/molecules/FeaturedText";
import EnrichModalHandler from "@/components/organisms/EnrichModalHandler";

const EnrichPage = () => {
  const { t } = useTranslation();
  const { showToast } = useToast();
  const [isDragging, setIsDragging] = useState(false);
  const [uploadedFile, setUploadedFile] = useState<File | null>(null);

  const handleDragOver = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    if (!isDragging) setIsDragging(true);
  };

  const handleDragLeave = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    setIsDragging(false);
  };

  const handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    setIsDragging(false);
    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      const file = e.dataTransfer.files[0];
      // Check if the file name ends with .csv
      if (file.name.toLowerCase().endsWith(".csv")) {
        setUploadedFile(file);
      } else {
        showToast({
          featuredIcon: { icon: HiOutlineXCircle, color: "error" },
          heading: t("enrich.dnd.onlyCsv"),
        });
      }
      e.dataTransfer.clearData();
    }
  };

  return (
    <div className={"w-full p-10"}>
      <div
        onDragOver={handleDragOver}
        onDragLeave={handleDragLeave}
        onDrop={handleDrop}
        className={clsx(
          "flex h-full w-full flex-1 items-center justify-center rounded border-2 border-dashed transition",
          isDragging && "border-brand-primary bg-brand-primary-subtle",
        )}
      >
        <FeaturedText
          heading={t("enrich.dnd.title")}
          body={t("enrich.dnd.description")}
          featuredIcon={{ icon: HiOutlineDocumentText, size: "xl" }}
          size={"lg"}
        >
          <div className={"mt-2"}>
            <EnrichModalHandler file={uploadedFile} />
          </div>
        </FeaturedText>
      </div>
    </div>
  );
};

export default EnrichPage;
